// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PrivateBenchmarkSummaryFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'isCustom': !exists(json, 'isCustom') ? undefined : json['isCustom'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'vintage': !exists(json, 'vintage') ? undefined : json['vintage'],
        'geography': !exists(json, 'geography') ? undefined : json['geography'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sizeClass': !exists(json, 'sizeClass') ? undefined : json['sizeClass'],
        'subStrategies': !exists(json, 'subStrategies') ? undefined : json['subStrategies'],
        'subGeographies': !exists(json, 'subGeographies') ? undefined : json['subGeographies'],
        'vintages': !exists(json, 'vintages') ? undefined : json['vintages'],
    };
}
export function PrivateBenchmarkSummaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'isCustom': value.isCustom,
        'type': value.type,
        'vintage': value.vintage,
        'geography': value.geography,
        'strategy': value.strategy,
        'source': value.source,
        'sizeClass': value.sizeClass,
    };
}
